<div class="bg-elevated border-weak flex h-full items-center gap-1.5 border-b px-4 py-2">
  <ng-content select="[filter-presets]"></ng-content>

  <div class="relative min-w-0 flex-1">
    <div class="filter-fade-left" [class.visible]="showLeftFade()"></div>

    <div
      #scrollContainer
      class="scrollbar-hide flex w-full items-center gap-1.5 overflow-x-auto"
      style="scroll-behavior: smooth"
      (scroll)="onScroll($event)">
      @if (hasComplexFilters()) {
        <button
          (click)="openComplexFilterBuilder()"
          class="hover:text-text-primary text-accent-main hover:bg-interactive border-accent-main flex shrink-0 cursor-pointer items-center gap-1.5 rounded-md border px-2 py-1 text-sm font-medium whitespace-nowrap transition-colors">
          <i [class]="ICONS.funnel + ' h-4 w-4'"></i>
          <span>{{ 'filters.advanced_filters' | translate }}</span>
        </button>
      }

      @for (pill of filterPills(); track trackPill(pill)) {
        <div #pillElement class="inline-flex shrink-0" data-pill-element>
          <app-filter-pill
            [label]="pill.label"
            [type]="pill.type"
            [operation]="pill.condition.operation"
            [operationLabel]="pill.operationLabel"
            [value]="pill.value"
            [active]="openPillId() === pill.condition.id"
            (clickOnPill)="openFilterPopup(pill, pillElement)"
            (removeFilter)="handleFilterRemoveByPill(pill)" />
        </div>
      }

      <app-button
        #addFilterButton
        (clickEvent)="openAddFilterDropdown(addFilterButton)"
        type="transparent"
        [label]="'filters.add_filter' | translate"
        [icon]="ICONS.plus" />
    </div>

    <div class="filter-fade-right" [class.visible]="showRightFade()"></div>
  </div>
</div>

<ng-template #filterPopupTemplate>
  @if (activeFilterCondition()) {
    <app-filter-popup
      [filterCondition]="activeFilterCondition()!"
      [availableValues]="availableValuesForActiveCondition()"
      (updateFiltering)="handleFilterUpdate($event)"
      (removeFiltering)="handleFilterRemove()"
      (closePopup)="dropdownService.close()" />
  }
</ng-template>

<ng-template #addFilterTemplate>
  <app-add-filter-dropdown
    [availableFields]="availableFields()"
    [activeFilters]="$any(filterConfiguration().rootGroup.conditions)"
    (addFiltering)="handleAddFilter($event)"
    (addComplexFiltering)="openComplexFilterBuilder()"
    (dropdownClose)="dropdownService.close()" />
</ng-template>

@if (showComplexFilterBuilder()) {
  <app-complex-filter-builder
    [filterConfiguration]="filterConfiguration()"
    [availableFields]="availableFields()"
    (filterUpdate)="handleComplexFilterUpdate($event)"
    (builderClosed)="closeComplexFilterBuilder()" />
}
